import {
  colorAccent,
  colorBlue,
  colorDarkRed,
  colorGreen,
  colorLightRed,
  colorRed,
  colorYellow,
} from '@/utils/palette';
import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip as BootstrapTooltip, OverlayTrigger } from 'react-bootstrap';
import styled from 'styled-components';

const Tooltip = ({ dir, text, variant, children, ...other }) => {
  // Move getColor function outside of StyledTooltip
  const getColor = (variant) => {
    switch (true) {
      case variant?.includes('primary'):
      case variant?.includes('unverified'):
        return colorBlue;
      case variant?.includes('Low'):
      case variant?.includes('success'):
        return colorAccent;
      case variant?.includes('warning'):
      case variant?.includes('Medium'):
      case variant?.includes('lowRisk'):
        return colorYellow;
      case variant?.includes('danger'):
      case variant?.includes('High'):
        return colorRed;
      case variant?.includes('mediumRisk'):
        return colorLightRed;
      case variant?.includes('None'):
      case variant?.includes('none'):
      case variant?.includes('Success'):
        return colorGreen;
      case variant?.includes('Critical'):
      case variant?.includes('critical'):
        return colorDarkRed;
      default:
        return colorBlue;
    }
  };

  const color = getColor(variant); // Calculate color based on variant

  const tooltip = (
    <StyledTooltip
      dir={dir}
      variant={variant}
      color={color}
    >
      {text}
    </StyledTooltip>
  );

  return (
    <OverlayTrigger
      overlay={tooltip}
      {...other}
    >
      {children}
    </OverlayTrigger>
  );
};

Tooltip.propTypes = {
  dir: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.string,
};

export default Tooltip;

// region STYLES

const StyledTooltip = styled(BootstrapTooltip)`
  z-index: 9999 !important;
  opacity: 1;

  .tooltip-inner {
    background-color: ${(props) => props.color};
    font-size: 12px;
    line-height: 14px;
  }

  &.bs-tooltip-end .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^='end'] .tooltip-arrow::before {
    border-right-color: ${(props) => props.color};
  }

  &.bs-tooltip-top .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^='top'] .tooltip-arrow::before {
    border-top-color: ${(props) => props.color};
  }

  &.bs-tooltip-bottom .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^='bottom'] .tooltip-arrow::before {
    border-bottom-color: ${(props) => props.color};
  }

  &.bs-tooltip-start .tooltip-arrow::before,
  &.bs-tooltip-auto[x-placement^='start'] .tooltip-arrow::before {
    border-left-color: ${(props) => props.color};
  }
`;

// endregion
